import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/api';
import toast from 'react-hot-toast';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSent, setIsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      await authApi.forgotPassword({ email });
      setIsSent(true);
      toast.success('Reset instructions sent to your email');
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Failed to send reset email');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSent) {
    return (
      <div className="text-center space-y-6">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-content">Check your email</h2>
        <p className="text-content-muted">
          We've sent password reset instructions to <strong>{email}</strong>
        </p>
        <Link to="/login" className="btn-primary inline-block">
          Back to sign in
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-content">Reset your password</h2>
        <p className="mt-2 text-sm text-content-muted">
          Enter your email and we'll send you reset instructions
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="email" className="label">
            Email address
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            placeholder="you@company.com"
            required
          />
        </div>

        <button
          type="submit"
          disabled={isLoading || !email}
          className="w-full btn-primary disabled:opacity-50"
        >
          {isLoading ? 'Sending...' : 'Send reset instructions'}
        </button>
      </form>

      <div className="text-center">
        <Link to="/login" className="text-sm font-medium text-brand-600 hover:text-brand-500">
          Back to sign in
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
